<template>
  <div>
    <div class="sida-accordion declaracao-propriedade-form">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="{item, active: index === activeItem}"
        class="accordion-item"
        :data-index="index"
        :id="'accordion-' + index"
      >
        <h1
          @click="onChangeAccordion(index)"
          class="accordion-title"
        >{{ item.nome_razao_social || ('Propriedade ' + (index + 1)) }}</h1>
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Nome/Razão social</label>
                  <input type="text" class="form-control" v-model="item.nome_razao_social" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label>Município</label>
                  <input
                    type="text"
                    class="form-control"
                    name="municipio_responsavel"
                    :id="'municipio-propriedade' + index"
                    v-model="item.municipio"
                  />

                  <input
                    type="hidden"
                    :id="'cod-municipio-propriedade' + index"
                    v-model="item.cod_municipio"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group required">
                  <label>UF</label>
                  <input type="text" class="form-control" v-model="item.uf" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Código ADAGRI</label>
                  <input type="text" class="form-control" v-model="item.cod_propriedade" disabled />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group required">
                  <label>Data da vacinação</label>
                  <datepicker-component
                    v-model="item.data_vacinacao"
                    input-class="form-control"
                  ></datepicker-component>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <h2>Bovídeos vacináveis para febre aftosa</h2>
                <div class="form-group required">
                  <input
                    type="text"
                    readonly
                    class="form-control input-message"
                    :value="bovideosValidValue(index)"
                    placeholder="Preencha informações dos Bovídeos"
                  />
                </div>
                <h3>Bovinos</h3>
                <table class="vertical">
                  <thead>
                    <tr>
                      <th>
                        <p>Faixa etária (meses)</p>
                      </th>
                      <th>
                        <p>Sexo</p>
                      </th>
                      <th>
                        <p>Existentes</p>
                      </th>
                      <th>
                        <p>Para abate</p>
                      </th>
                      <th>
                        <p>Vacinados Aftosa</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="2">0 a 12</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['0a12_M']"
                          data-type="existentes"
                          data-faixa="0a12_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['0a12_M']"
                          data-type="abate"
                          data-faixa="0a12_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['0a12_M']"
                          data-type="vacinados"
                          data-faixa="0a12_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['0a12_F']"
                          data-type="existentes"
                          data-faixa="0a12_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['0a12_F']"
                          data-type="abate"
                          data-faixa="0a12_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['0a12_F']"
                          data-type="vacinados"
                          data-faixa="0a12_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">13 a 24</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['13a24_M']"
                          data-type="existentes"
                          data-faixa="13a24_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['13a24_M']"
                          data-type="abate"
                          data-faixa="13a24_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['13a24_M']"
                          data-type="vacinados"
                          data-faixa="13a24_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['13a24_F']"
                          data-type="existentes"
                          data-faixa="13a24_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['13a24_F']"
                          data-type="abate"
                          data-faixa="13a24_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['13a24_F']"
                          data-type="vacinados"
                          data-faixa="13a24_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">25 a 36</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['25a36_M']"
                          data-type="existentes"
                          data-faixa="25a36_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['25a36_M']"
                          data-type="abate"
                          data-faixa="25a36_M"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['25a36_M']"
                          data-type="vacinados"
                          data-faixa="25a36_M"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['25a36_F']"
                          data-type="existentes"
                          data-faixa="25a36_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['25a36_F']"
                          data-type="abate"
                          data-faixa="25a36_F"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['25a36_F']"
                          data-type="vacinados"
                          data-faixa="25a36_F"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">+ de 36</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['mais36_M']"
                          data-type="existentes"
                          data-faixa="mais36_M"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['mais36_M']"
                          data-type="abate"
                          data-faixa="mais36_M"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['mais36_M']"
                          data-type="vacinados"
                          data-faixa="mais36_M"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.existentes['mais36_F']"
                          data-type="existentes"
                          data-faixa="mais36_F"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.abate['mais36_F']"
                          data-type="abate"
                          data-faixa="mais36_F"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.vacinados['mais36_F']"
                          data-type="vacinados"
                          data-faixa="mais36_F"
                          data-especie="bovinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">Total</td>
                      <td>M</td>
                      <td>{{ getTotal(item.bovinos.existentes, 'M') }}</td>
                      <td>{{ getTotal(item.bovinos.abate, 'M') }}</td>
                      <td>{{ getTotal(item.bovinos.vacinados, 'M') }}</td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>{{ getTotal(item.bovinos.existentes, 'F') }}</td>
                      <td>{{ getTotal(item.bovinos.abate, 'F') }}</td>
                      <td>{{ getTotal(item.bovinos.vacinados, 'F') }}</td>
                    </tr>
                    <tr>
                      <td colspan="4">N° de fêmeas de 03 a 08 meses:</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bovinos.femeas3a8"
                          data-type="femeas3a8"
                          data-especie="bovinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h3>Bubalinos</h3>
                <table class="vertical">
                  <thead>
                    <tr>
                      <th>
                        <p>Faixa etária (meses)</p>
                      </th>
                      <th>
                        <p>Sexo</p>
                      </th>
                      <th>
                        <p>Existentes</p>
                      </th>
                      <th>
                        <p>Para abate</p>
                      </th>
                      <th>
                        <p>Vacinados Aftosa</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="2">0 a 12</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['0a12_M']"
                          data-type="existentes"
                          data-faixa="0a12_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['0a12_M']"
                          data-type="abate"
                          data-faixa="0a12_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['0a12_M']"
                          data-type="vacinados"
                          data-faixa="0a12_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['0a12_F']"
                          data-type="existentes"
                          data-faixa="0a12_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['0a12_F']"
                          data-type="abate"
                          data-faixa="0a12_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['0a12_F']"
                          data-type="vacinados"
                          data-faixa="0a12_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">13 a 24</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['13a24_M']"
                          data-type="existentes"
                          data-faixa="13a24_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['13a24_M']"
                          data-type="abate"
                          data-faixa="13a24_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['13a24_M']"
                          data-type="vacinados"
                          data-faixa="13a24_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['13a24_F']"
                          data-type="existentes"
                          data-faixa="13a24_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['13a24_F']"
                          data-type="abate"
                          data-faixa="13a24_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['13a24_F']"
                          data-type="vacinados"
                          data-faixa="13a24_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">25 a 36</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['25a36_M']"
                          data-type="existentes"
                          data-faixa="25a36_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['25a36_M']"
                          data-type="abate"
                          data-faixa="25a36_M"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['25a36_M']"
                          data-type="vacinados"
                          data-faixa="25a36_M"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['25a36_F']"
                          data-type="existentes"
                          data-faixa="25a36_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['25a36_F']"
                          data-type="abate"
                          data-faixa="25a36_F"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['25a36_F']"
                          data-type="vacinados"
                          data-faixa="25a36_F"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">+ de 36</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['mais36_M']"
                          data-type="existentes"
                          data-faixa="mais36_M"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['mais36_M']"
                          data-type="abate"
                          data-faixa="mais36_M"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['mais36_M']"
                          data-type="vacinados"
                          data-faixa="mais36_M"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.existentes['mais36_F']"
                          data-type="existentes"
                          data-faixa="mais36_F"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.abate['mais36_F']"
                          data-type="abate"
                          data-faixa="mais36_F"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.vacinados['mais36_F']"
                          data-type="vacinados"
                          data-faixa="mais36_F"
                          data-especie="bubalinos"
                          :data-index="index"
                          :disabled=desativado
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">Total</td>
                      <td>M</td>
                      <td>{{ getTotal(item.bubalinos.existentes, 'M') }}</td>
                      <td>{{ getTotal(item.bubalinos.abate, 'M') }}</td>
                      <td>{{ getTotal(item.bubalinos.vacinados, 'M') }}</td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>{{ getTotal(item.bubalinos.existentes, 'F') }}</td>
                      <td>{{ getTotal(item.bubalinos.abate, 'F') }}</td>
                      <td>{{ getTotal(item.bubalinos.vacinados, 'F') }}</td>
                    </tr>
                    <tr>
                      <td colspan="4">N° de fêmeas de 03 a 08 meses:</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.bubalinos.femeas3a8"
                          data-type="femeas3a8"
                          data-especie="bubalinos"
                          :data-index="index"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h2>Informações de outras espécies animais</h2>
                <table class="vertical my-1">
                  <thead>
                    <tr>
                      <th>
                        <p>Faixa etária (meses)</p>
                      </th>
                      <th>
                        <p>Sexo</p>
                      </th>
                      <th>
                        <p>Ovinos Existentes</p>
                      </th>
                      <th>
                        <p>Caprinos Existentes</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="2">0 a 12</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.ovinos.existentes['0a12_M']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.caprinos.existentes['0a12_M']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.ovinos.existentes['0a12_F']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.caprinos.existentes['0a12_F']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">+ de 12</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.ovinos.existentes['mais12_M']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.caprinos.existentes['mais12_M']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.ovinos.existentes['mais12_F']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.caprinos.existentes['mais12_F']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">Total</td>
                      <td>M</td>
                      <td>{{ getTotal(item.outrasEspecies.ovinos.existentes, 'M') }}</td>
                      <td>{{ getTotal(item.outrasEspecies.caprinos.existentes, 'M') }}</td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>{{ getTotal(item.outrasEspecies.ovinos.existentes, 'F') }}</td>
                      <td>{{ getTotal(item.outrasEspecies.caprinos.existentes, 'F') }}</td>
                    </tr>
                  </tbody>
                </table>

                <table class="vertical my-1">
                  <thead>
                    <tr>
                      <th>
                        <p>Faixa etária (meses)</p>
                      </th>
                      <th>
                        <p>Sexo</p>
                      </th>
                      <th>
                        <p>Equinos Existentes</p>
                      </th>
                      <th>
                        <p>Muares Existentes</p>
                      </th>
                      <th>
                        <p>Asininos Existentes</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="2">0 a 6</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.equinos.existentes['0a6_M']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.muares.existentes['0a6_M']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.asininos.existentes['0a6_M']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.equinos.existentes['0a6_F']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.muares.existentes['0a6_F']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.asininos.existentes['0a6_F']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">+ de 6</td>
                      <td>M</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.equinos.existentes['mais6_M']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.muares.existentes['mais6_M']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.asininos.existentes['mais6_M']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.equinos.existentes['mais6_F']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.muares.existentes['mais6_F']"
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          v-numeric
                          v-model.number="item.outrasEspecies.asininos.existentes['mais6_F']"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="2">Total</td>
                      <td>M</td>
                      <td>{{ getTotal(item.outrasEspecies.equinos.existentes, 'M') }}</td>
                      <td>{{ getTotal(item.outrasEspecies.muares.existentes, 'M') }}</td>
                      <td>{{ getTotal(item.outrasEspecies.asininos.existentes, 'M') }}</td>
                    </tr>
                    <tr>
                      <td>F</td>
                      <td>{{ getTotal(item.outrasEspecies.equinos.existentes, 'F') }}</td>
                      <td>{{ getTotal(item.outrasEspecies.muares.existentes, 'F') }}</td>
                      <td>{{ getTotal(item.outrasEspecies.asininos.existentes, 'F') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-4">
                <h2>Suínos</h2>
                <div class="content-table">
                  <table>
                    <thead>
                      <tr>
                        <th colspan="2"></th>
                        <th>Existentes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">Macho</td>
                        <td>Reprodutor</td>
                        <td>
                          <input type="tel" v-numeric v-model.number="item.suinos.macho.reprodutor" />
                        </td>
                      </tr>
                      <tr>
                        <td>Leitão</td>
                        <td>
                          <input type="tel" v-numeric v-model.number="item.suinos.macho.leitao" />
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2">Fêmea</td>
                        <td>Matriz</td>
                        <td>
                          <input type="tel" v-numeric v-model.number="item.suinos.femea.matriz" />
                        </td>
                      </tr>
                      <tr>
                        <td>Leitão</td>
                        <td>
                          <input type="tel" v-numeric v-model.number="item.suinos.femea.leitao" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">Sexo e idade não relevantes</td>
                        <td>
                          <input
                            type="tel"
                            v-numeric
                            v-model.number="item.suinos.sexo_idade_irreleventes"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h2>Outros</h2>
                <div class="content-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Aves</th>
                        <th>Quantitativo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Galinha</td>
                        <td>
                          <input type="tel" v-numeric v-model.number="item.outros.galinhas" />
                        </td>
                      </tr>
                      <tr>
                        <td>Outras espécies</td>
                        <td>
                          <input type="tel" v-model="item.outros.outrasEspecies" maxlength="255" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="content-table">
                  <table>
                    <tbody>
                      <tr>
                        <td>Abelhas</td>
                        <td>
                          <label>
                            SIM
                            <input
                              type="radio"
                              :name="'abelhas[' + index + ']'"
                              value="sim"
                              v-model="item.outros.abelhas"
                            />
                          </label>
                          <label>
                            NÃO
                            <input
                              type="radio"
                              :name="'abelhas[' + index + ']'"
                              value="nao"
                              v-model="item.outros.abelhas"
                            />
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>Aquáticos</td>
                        <td>
                          <label>
                            SIM
                            <input
                              type="radio"
                              :name="'aquaticos[' + index + ']'"
                              value="sim"
                              v-model="item.outros.aquaticos"
                            />
                          </label>
                          <label>
                            NÃO
                            <input
                              type="radio"
                              :name="'aquaticos[' + index + ']'"
                              value="nao"
                              v-model="item.outros.aquaticos"
                            />
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="btn-primary" @click="finishProperty(index)">
                  <span>Finalizei o cadastro dessa propriedade</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <input type="hidden" name="propriedades_json" :value="JSON.stringify(items)" />
  </div>
</template>

<script>
export default {
  props: {
    propriedades: {
      required: true
    }
  },
  watch: {
    propriedades: function(propriedades) {
      this.items = [];
      propriedades.forEach(propriedade => {
        const emptyItem = {
          cod_propriedade: propriedade.codpropriedade,
          nome_razao_social: propriedade.nomepropriedade,
          municipio: propriedade.aux.ds_municipio,
          cod_municipio: propriedade.aux.cd_municipio,
          uf: propriedade.aux.cd_estado,
          data_vacinacao: "",
          bovinos: {
            femeas3a8: "",
            existentes: {
              "0a12_M": "",
              "0a12_F": "",
              "13a24_M": "",
              "13a24_F": "",
              "25a36_M": "",
              "25a36_F": "",
              mais36_M: "",
              mais36_F: ""
            },
            vacinados: {
              "0a12_M": "",
              "0a12_F": "",
              "13a24_M": "",
              "13a24_F": "",
              "25a36_M": "",
              "25a36_F": "",
              mais36_M: "",
              mais36_F: ""
            },
            abate: {
              "0a12_M": "",
              "0a12_F": "",
              "13a24_M": "",
              "13a24_F": "",
              "25a36_M": "",
              "25a36_F": "",
              mais36_M: "",
              mais36_F: ""
            }
          },
          bubalinos: {
            femeas3a8: "",
            existentes: {
              "0a12_M": "",
              "0a12_F": "",
              "13a24_M": "",
              "13a24_F": "",
              "25a36_M": "",
              "25a36_F": "",
              mais36_M: "",
              mais36_F: ""
            },
            vacinados: {
              "0a12_M": "",
              "0a12_F": "",
              "13a24_M": "",
              "13a24_F": "",
              "25a36_M": "",
              "25a36_F": "",
              mais36_M: "",
              mais36_F: ""
            },
            abate: {
              "0a12_M": "",
              "0a12_F": "",
              "13a24_M": "",
              "13a24_F": "",
              "25a36_M": "",
              "25a36_F": "",
              mais36_M: "",
              mais36_F: ""
            }
          },
          outrasEspecies: {
            ovinos: {
              existentes: {
                "0a12_M": "",
                "0a12_F": "",
                mais12_M: "",
                mais12_F: ""
              }
            },
            caprinos: {
              existentes: {
                "0a12_M": "",
                "0a12_F": "",
                mais12_M: "",
                mais12_F: ""
              }
            },
            muares: {
              existentes: {
                "0a6_M": "",
                "0a6_F": "",
                mais6_M: "",
                mais6_F: ""
              }
            },
            asininos: {
              existentes: {
                "0a6_M": "",
                "0a6_F": "",
                mais6_M: "",
                mais6_F: ""
              }
            },
            equinos: {
              existentes: {
                "0a6_M": "",
                "0a6_F": "",
                mais6_M: "",
                mais6_F: ""
              }
            }
          },
          suinos: {
            macho: {
              reprodutor: "",
              leitao: ""
            },
            femea: {
              matriz: "",
              leitao: ""
            },
            sexo_idade_irreleventes: ""
          },
          outros: {
            galinhas: "",
            outrasEspecies: "",
            abelhas: "nao",
            aquaticos: "nao"
          }
        };

        this.items.push(emptyItem);
      });

      this.activeItem = null;

      setTimeout(() => {
        for (let i = 0; i < propriedades.length; i++) {
          Geral.makeAutocomplete(
            $("#municipio-propriedade" + i),
            $("#cod-municipio-propriedade" + i),
            $("#lb-municipio"),
            {},
            "/public/get-municipio-ceara-autocomplete"
          );
        }

        this.addInputsListeners();
      }, 500);
    }
  },
  data: () => ({
    items: [],
    desativado: false,
    activeItem: null,
    tiposAtividade: [],
    hectareMask: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: " ha",
      precision: 2
    },
    femeas3a8TimeoutId: null
  }),
  methods: {
    onSavePropriedades(ev) {
      this.items[this.activeItem].exploracoes = ev;
    },
    getTotal(list, sexo) {
      let total = 0;
      Object.keys(list).forEach(key => {
        if (key.endsWith(`_${sexo}`) && !isNaN(parseInt(list[key]))) {
          total += parseInt(list[key]);
        }
      });
      return total;
    },
    onChangeAccordion(index) {
      this.activeItem = index;

      const beforeIndex = index == 0 ? index : index - 1;

      var accordionItem = document.getElementById("accordion-" + beforeIndex);
      var topPos = accordionItem.offsetTop;
      $("html, body").animate(
        {
          scrollTop: topPos
        },
        1000
      );
    },
    bovideosValidValue(index) {
      let value = "";
      Object.keys(this.items[index].bovinos.existentes).forEach(key => {
        const existentes = this.items[index].bovinos.existentes[key];

        if (String(existentes).replace(/\D/g, "") != "") {
          value = "1";
        }
      });
      Object.keys(this.items[index].bubalinos.existentes).forEach(key => {
        const existentes = this.items[index].bubalinos.existentes[key];

        if (String(existentes).replace(/\D/g, "") != "") {
          value = "1";
        }
      });
      return value;
    },
    finishProperty(index) {
      let hasError = false;
      let focusSeted = false;
      if((this.getTotal(this.items[index].bovinos.existentes, 'M') != this.getTotal(this.items[index].bovinos.abate, 'M') + this.getTotal(this.items[index].bovinos.vacinados, 'M')) || (this.getTotal(this.items[index].bovinos.existentes, 'F') != this.getTotal(this.items[index].bovinos.abate, 'F') + this.getTotal(this.items[index].bovinos.vacinados, 'F')) || (this.getTotal(this.items[index].bubalinos.existentes, 'M') != this.getTotal(this.items[index].bubalinos.abate, 'M') + this.getTotal(this.items[index].bubalinos.vacinados, 'M')) || (this.getTotal(this.items[index].bubalinos.existentes, 'F') != this.getTotal(this.items[index].bubalinos.abate, 'F') + this.getTotal(this.items[index].bubalinos.vacinados, 'F'))) {
        alert('Você tem animais não vacinados. Revise os dados e tente novamente.')
      } else {
        return 0;
      }
      this.$el
        .querySelector(".container.active #accordion-" + index)
        .querySelectorAll(".form-group.required")
        .forEach(node => {
          const formControl = node.querySelector(".form-control");
          if (formControl && !formControl.value) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              formControl.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      if (!hasError) {
        if (index < this.items.length - 1) {
          this.onChangeAccordion(index + 1);
        } else {
          this.$emit("nextStep");
        }
      }
    },
    addInputsListeners() {
      const onChangeControlInputsEvent = ev => {
        const input = ev.target;
        const itemType = input.getAttribute("data-type");
        if (itemType) {
          const faixa = input.getAttribute("data-faixa");
          const especie = input.getAttribute("data-especie");
          const index = input.getAttribute("data-index");

          if (itemType === "femeas3a8") {
            if (this.items[index][especie].existentes["0a12_F"] != "") {
              const existentes = parseInt(
                this.items[index][especie].existentes["0a12_F"]
              );

              if (this.items[index][especie].femeas3a8 != "") {
                const femeas3a8 = parseInt(
                  this.items[index][especie].femeas3a8
                );

                if (femeas3a8 > existentes) {
                  this.items[index][especie].femeas3a8 = existentes;
                }
              }
            }
          } else if (
            this.items[index][especie].existentes[faixa] != "" &&
            itemType !== "existentes"
          ) {
            if (
              itemType == "abate" &&
              this.items[index][especie].abate[faixa] !== ""
            ) {
              const existentes = parseInt(
                this.items[index][especie].existentes[faixa]
              );
              let abate = parseInt(this.items[index][especie].abate[faixa]);

              if (existentes < abate) {
                abate = this.items[index][especie].abate[faixa] = existentes;
              }

              this.items[index][especie].vacinados[faixa] = existentes - abate;
            } else if (
              itemType == "vacinados" &&
              this.items[index][especie].vacinados[faixa] !== ""
            ) {
              const existentes = parseInt(
                this.items[index][especie].existentes[faixa]
              );
              let vacinados = parseInt(
                this.items[index][especie].vacinados[faixa]
              );

              if (existentes < vacinados) {
                vacinados = this.items[index][especie].vacinados[
                  faixa
                ] = existentes;
              }

              this.items[index][especie].abate[faixa] = existentes - vacinados;
            }
          } else if (
            this.items[index][especie].existentes[faixa] != "" &&
            itemType === "existentes"
          ) {
            if (
              faixa == "0a12_F" &&
              this.items[index][especie].femeas3a8 != ""
            ) {
              clearTimeout(this.femeas3a8TimeoutId);
              this.femeas3a8TimeoutId = setTimeout(() => {
                const existentes = parseInt(
                  this.items[index][especie].existentes["0a12_F"]
                );
                const femeas3a8 = parseInt(
                  this.items[index][especie].femeas3a8
                );

                if (femeas3a8 > existentes) {
                  this.items[index][especie].femeas3a8 = existentes;
                }
              }, 1500);
            }
          } else {
            this.items[index][especie].abate[faixa] = "";
            this.items[index][especie].vacinados[faixa] = "";
          }
        }
      };

      document
        .querySelectorAll("input[type='tel'][data-type]")
        .forEach(input => {
          input.addEventListener("input", onChangeControlInputsEvent);
        });
    }
  },
  mounted() {
    const scope = this;

    this.activeItem = 0;

    $(document).on(
      "focus",
      ".declaracao-propriedade-form .form-group.required .form-control",
      function(ev) {
        const accordionItem = ev.target.closest(".accordion-item");
        const index = parseInt(accordionItem.getAttribute("data-index"));
        scope.activeItem = index;
      }
    );
  }
};
</script>
<style lang="scss" scoped>
.content-table {
  overflow-x: auto;
  padding-bottom: 20px;
}

.input-message {
  background: #fff !important;
  border: none !important;
  font-weight: bold;
  padding: 0 !important;
  color: transparent !important;
}

.form-group.error .form-control.input-message::placeholder {
  color: red !important;
}

table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #222;
    font-weight: normal;
    color: #000;
  }

  thead {
    background: #b5b5b5;

    th {
      padding: 5px;
      font-weight: bold;
    }
  }

  tbody {
    tr {
      td {
        padding: 0;
        text-align: center;

        input[type="tel"],
        input[type="text"] {
          width: 40px;
          min-width: 100%;
          border-radius: 0;
          border: 1px solid transparent;

          &:focus {
            border-color: #31813c;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    &.vertical {
      text-align: center;
      table-layout: fixed;
      thead {
        th {
          text-align: center;
          white-space: nowrap;
          transform: rotate(-90deg);

          p {
            margin: 0 -100%;
            display: inline-block;

            &:before {
              content: "";
              width: 0;
              padding-top: 110%; /* takes width as reference, + 10% for faking some extra padding */
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }

      .vertical {
        text-align: center;
        white-space: nowrap;
        transform: rotate(-90deg);

        p {
          margin: 0 -100%;
          display: inline-block;

          &:before {
            content: "";
            width: 0;
            padding-top: 110%; /* takes width as reference, + 10% for faking some extra padding */
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
